export const FixedDesignDescriptionForm = {
  title: 'Description',
  key: [],
  sections: [
    {
      columns: 2,
      fields: [
        {
          label: 'Name (EN)',
          placeholder: 'Name in English',
          isRequired: true,
          key: ['name', 'en'],
          pos: { col: 1, row: 1, size: 1 },
        },
        {
          label: 'Name (中文)',
          placeholder: 'Name in Chinese',
          key: ['name', 'zh'],
          pos: { col: 1, row: 2, size: 1 },
        },
        {
          label: 'SKU',
          placeholder: 'Ref ID',
          isRequired: true,
          key: ['sku'],
          pos: { col: 1, row: 3, size: 1 },
        },
        {
          label: 'Description (EN)',
          type: 'text',
          placeholder: 'Description in English',
          key: ['description', 'en'],
          pos: { col: 1, row: 5, size: 1 },
        },
        {
          label: 'Description (中文)',
          type: 'text',
          placeholder: 'Description in Chinese',
          key: ['description', 'zh'],
          pos: { col: 1, row: 6, size: 1 },
        },
      ],
    },
  ],
}

export const FixedDesignOptionsForm = {
  title: 'Options',
  key: [],
  sections: [
    {
      canAdd: true,
      key: ['options'],
      addSuffix: 'number',
      columns: 4,
      noDivider: true,
      title: 'Option',
      deleteBtn: { label: 'Delete', style: 'title' },
      addBtn: { label: 'Add option', style: 'primary' },
      fields: [
        {
          label: 'Option English Name',
          key: ['name', 'en'],
          isRequired: true,
          pos: {
            col: 1,
            row: 1,
            size: 1,
          },
        },
        {
          label: 'Option Chinese Name',
          key: ['name', 'zh'],
          isRequired: true,
          pos: {
            col: 2,
            row: 1,
            size: 1,
          },
        },
        {
          label: 'Free field',
          key: ['freeField'],
          type: 'switch',
          pos: {
            col: 3,
            row: 1,
            size: 1,
          },
        },
      ],
      sections: [
        {
          canAdd: true,
          key: ['subOptions'],
          columns: 4,
          noDivider: true,
          deleteBtn: {
            label: 'Delete',
            style: 'line',
          },
          addBtn: { label: 'Add sub-option', style: 'dashed' },
          fields: [
            {
              key: ['name', 'en'],
              placeholder: 'Sub option English name',
              isRequired: true,
              pos: {
                col: 1,
                row: 1,
                size: 1,
              },
            },
            {
              key: ['name', 'zh'],
              placeholder: 'Sub option Chinese name',
              isRequired: true,
              pos: {
                col: 2,
                row: 1,
                size: 1,
              },
            },
            {
              key: ['ref'],
              placeholder: 'Ref ID',
              isRequired: true,
              pos: {
                col: 3,
                row: 1,
                size: 1,
              },
            },
          ],
        },
      ],
    },
  ],
}
